// extracted by mini-css-extract-plugin
module.exports = {"ContentPageWrapper":"ContentPage_ContentPageWrapper_20KvX"};